import { ReviewResult } from "@/types/review";

export function exportReviewResults(reviews: ReviewResult[]): string {
  const headers = [
    "nces_id",
    "district_name",
    "review_status",
    "reviewer_notes",
    "review_timestamp",
    "session_id",
    "reviewed_url",
  ];

  const csvContent = [
    headers.join(","),
    ...reviews.map((review) =>
      [
        review.nces_id,
        `"${review.district_name}"`,
        review.review_status,
        `"${review.reviewer_notes.replace(/"/g, '""')}"`,
        review.review_timestamp,
        review.session_id,
        `"${review.reviewed_url}"`,
      ].join(","),
    ),
  ].join("\n");

  return csvContent;
}
